import React from 'react';

import './CommonModal.component.scss';


function CommonModal({
    isOpen,
    onClose,
    title,
    children,
    footer,
    modalClassName = '',
    contentClassName = ''
}) {
    if (!isOpen) return null;

    return (
        <div className='common-modal-overlay'>
            <div className={`common-modal${modalClassName ? ` ${modalClassName}` : ''}`}
                role='dialog'
                aria-modal='true'
                onClick={(event) => event.stopPropagation()}
            >
                <button className='common-modal-close-icon' onClick={onClose} aria-label='Close modal'>
                    <svg viewBox="0 0 32 32" fill="none">
                        <path d="M32 4.03186L27.9681 0L16.0116 11.9566L4.03186 0L0 4.03186L11.9566 16.0116L0 27.9681L4.03186 32L16.0116 20.0434L27.9681 32L32 27.9681L20.0434 16.0116L32 4.03186Z" fill="currentColor" />
                    </svg>
                </button>

                {title ? <h4 className='common-modal-title'>{title}</h4> : null}

                <div className={`common-modal-content${contentClassName ? ` ${contentClassName}` : ''}`}>
                    {children}
                </div>

                {footer ? <div className='common-modal-footer'>{footer}</div> : null}
            </div>
        </div>
    );
}


export default CommonModal;